import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { apiService } from "../../services/api";
import { LogoSVG } from "../Common/LogoSVG";
import { LangContext } from "../../contexts/LangContext";
import en from "../../i18n/en";
import pl from "../../i18n/pl";

export function VerifyEmailPage() {
  const { lang } = React.useContext(LangContext);
  const t = lang === "pl" ? pl : en;
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    
    if (!token) {
      setStatus("error");
      setMessage(t.verifyInvalidToken || "Invalid verification link");
      return;
    }

    const verifyEmail = async () => {
      try {
        await apiService.verifyEmail(token);
        window.location.href = "/login"
      } catch (err) {
        window.location.href = "/login"
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-brand">
          <div className="auth-brand-icon">
            <LogoSVG size={26} />
          </div>
          <h1>{t.appName}</h1>
        </div>
        <div className="auth-card" style={{ textAlign: "center", padding: "40px 30px" }}>
          {status === "loading" && (
            <>
              <div className="spinner" style={{ margin: "0 auto 20px" }} />
              <p style={{ color: "var(--muted)", fontSize: 14 }}>
                {t.verifyInProgress || "Verifying your email..."}
              </p>
            </>
          )}

          {status === "success" && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <h2 style={{ fontSize: 20, marginBottom: 8, color: "var(--dark)" }}>
                {t.verifySuccessTitle || "Email Verified!"}
              </h2>
              <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 24 }}>
                {message}
              </p>
              <a href="/login" className="btn-primary" style={{ display: "inline-block", textDecoration: "none" }}>
                {t.goToLogin || "Go to Login"}
              </a>
            </>
          )}

          {status === "error" && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
              <h2 style={{ fontSize: 20, marginBottom: 8, color: "var(--dark)" }}>
                {t.verifyErrorTitle || "Verification Failed"}
              </h2>
              <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 24 }}>
                {message}
              </p>
              <a href="/login" className="btn-primary" style={{ display: "inline-block", textDecoration: "none" }}>
                {t.goToLogin || "Go to Login"}
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}